// Garden selector UI for choosing from available gardens

import { t } from '@/i18n'
import { debug } from '@/utils/debug'
import { gardenSelector, gardenList } from './elements'
import { hideLoading } from './loading'

/**
 * Show garden selector with list of gardens
 */
export function showGardenSelector(gardens: { id: string; name: string }[]): void {
  hideLoading()

  // Clear existing list
  gardenList.innerHTML = ''

  // "New Garden" button — always shown at the top
  const newBtn = document.createElement('div')
  newBtn.className = 'garden-item garden-item--new'
  const newLabel = document.createElement('div')
  newLabel.className = 'garden-item-name'
  newLabel.textContent = t('selector.newGarden')
  newBtn.appendChild(newLabel)
  newBtn.addEventListener('click', () => {
    debug.log('Garden', 'New garden selected')
    const url = new URL(window.location.href)
    url.searchParams.set('new', 'true')
    url.searchParams.set('edit', 'true')
    url.searchParams.delete('garden')
    window.location.href = url.toString()
  })
  gardenList.appendChild(newBtn)

  if (gardens.length === 0) {
    // Show empty state (below the new button)
    const emptyDiv = document.createElement('div')
    emptyDiv.className = 'garden-empty'
    emptyDiv.textContent = t('selector.empty')
    gardenList.appendChild(emptyDiv)
  } else {
    // Populate list with garden items
    for (const garden of gardens) {
      const item = document.createElement('div')
      item.className = 'garden-item'
      item.dataset.gardenId = garden.id

      const nameDiv = document.createElement('div')
      nameDiv.className = 'garden-item-name'
      nameDiv.textContent = garden.name || t('ui.defaultGardenName')

      const idDiv = document.createElement('div')
      idDiv.className = 'garden-item-id'
      idDiv.textContent = `ID: ${garden.id}`

      item.appendChild(nameDiv)
      item.appendChild(idDiv)

      // Click handler — reload page with garden param for a clean load
      item.addEventListener('click', () => {
        debug.log('Garden', `Selected garden: ${garden.id}`)
        const url = new URL(window.location.href)
        url.searchParams.set('garden', garden.id)
        url.searchParams.set('edit', 'true')
        url.searchParams.delete('new')
        window.location.href = url.toString()
      })

      gardenList.appendChild(item)
    }
  }

  gardenSelector.classList.remove('hidden')
  debug.log('App', `Showing garden selector with ${gardens.length} gardens`)
}

/**
 * Hide garden selector
 */
export function hideGardenSelector(): void {
  gardenSelector.classList.add('hidden')
}
